export const enum CounterofferStatus {
	CANCELED = 'CANCELED',
	COMPLETED = 'COMPLETED',
	ACTIVE = 'ACTIVE',
	PENDING = 'PENDING',
}
